import { render, staticRenderFns } from "./Advertising.vue?vue&type=template&id=e0792594&scoped=true&"
import script from "./Advertising.vue?vue&type=script&lang=js&"
export * from "./Advertising.vue?vue&type=script&lang=js&"
import style0 from "./Advertising.vue?vue&type=style&index=0&id=e0792594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0792594",
  null
  
)

export default component.exports